import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom'

class UnAuthorized extends PureComponent {
  componentWillUnmount () {
    localStorage.removeItem('pos-confirm')
    localStorage.removeItem('posPackage')
  }

  render () {
    return (
      <div className='account'>
        <div className='account__wrapper'>
          <div className='account__card'>
            <div className='account__head'>
              <h3 className='account__title'>Oooops! Unable to access this page.</h3>
              <h4 id='header' className='account__subhead subhead'>
                You signed out. Please sign in again to view requested page.
              </h4>
              <Link id='login' to='/' className='btn btn-primary account__btn account__btn--small'>Sign In</Link>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default UnAuthorized



// WEBPACK FOOTER //
// ./src/components/account/log_in/components/UnAuthorized.js